<app-modal-main class="online-form-address-modal">
  <app-modal-main-content>
    <app-modal-header>
      <app-modal-title>{{ 'modals.onlineFormAddress.title' | translate }}</app-modal-title>
      <app-paragraph [font-size]="'small'">{{ 'modals.onlineFormAddress.description' | translate }}</app-paragraph>
    </app-modal-header>
    <app-form [formGroup]="form" (submited)="send()">
      <app-form-inputs>
        <app-input [label]="'forms.street' | translate" [required]="true" [name]="'street'" [formControlName]="'street'" [error]="form.controls['street'].invalid && form.controls['street'].touched" [error-message]="'forms.inputError' | translate"></app-input>
        <app-input [label]="'forms.zip' | translate" [required]="true" [name]="'zip'" [formControlName]="'zip'" [error]="form.controls['zip'].invalid && form.controls['zip'].touched" [error-message]="'forms.inputError' | translate"></app-input>
        <app-input [label]="'forms.city' | translate" [required]="true" [name]="'city'" [formControlName]="'city'" [error]="form.controls['city'].invalid && form.controls['city'].touched" [error-message]="'forms.inputError' | translate"></app-input>
      </app-form-inputs>
      <app-button [type]="'submit'" [disabled]="form.invalid">{{ 'forms.confirm' | translate }}</app-button>
    </app-form>
    <div class="online-form-address-modal__price">
      <strong class="online-form-address-modal__price-title">{{ 'modals.onlineFormAddress.price.title' | translate }}</strong>
      <ul class="online-form-address-modal__price-list">
        @for (item of 'modals.onlineFormAddress.price.items' | translate; track $index) {
          <li class="online-form-address-modal__price-list-item">
            {{ item.title }} <app-color-text [color]="'primary'">{{ item.price | thousands }},-</app-color-text>
          </li>
        }
      </ul>
    </div>
  </app-modal-main-content>
</app-modal-main>
